<template>
    <div class="landing-page__content-list" :style="`background: ${props.section?.backgroundColor || '#ffffff'}`">
        <div class="contents" :class="`contents__collumn-${contentCollumns}`">
            <section 
            class="content" 
            :class="`content--${content?.contentReverse ? 'reverse' : 'default'} content--media-${content.mediaType}`"
            v-for="(content, index) of section.contents" :key="index">
                <div class="content__media">
                    <img 
                        v-if="content.media && content.mediaType == 'image'" 
                        class="content__image" 
                        :src="content.media" alt="" />
                    <sib-video
                        v-else-if="content.media && content.mediaType == 'video'"
                        class="content__video"
                        :style="'width:100%;border-radius: 10px;'"
                        :src="content.media"
                        autoplay
                        preload="none"
                    ></sib-video>
                </div>
                <div class="content__text" v-html="content.text"></div>
            </section>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
const props = withDefaults(defineProps<{ section: any }>(), {})

const contentCollumns = computed(() => {
    return props.section?.contentColumns || 1
})

</script>

<style lang="scss">
.landing-page__content-list {
   .title {
        font-size: 23px;
        font-weight: bold;
        text-align: center;
        margin: 2rem 0;
        @include media-md-up {
        font-size: 26px;
        }
    }
    .description{
        font-size: 14px;
        font-weight: 400;
        @include media-md-up {
        font-size: 16px;
        }
    }
   
    .contents {
        padding: 1.5rem 0;
        display: grid;
        grid-template-columns: 1fr;
        gap: 1.5rem;

        @include media-md-up() {
            grid-template-columns: 1fr;
        }
    }
    .contents__collumn-2 {
        @include media-md-up() {
            grid-template-columns: 1fr 1fr;
        }
    }
    .content--media-video {
        @include media-md-up() {
            grid-template-columns: 1fr 60% !important;
        }
    }
    .content {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
        grid-template-areas: 
            'a'
            'b';
    
        @include media-md-up() {
            grid-template-areas: 'a b';
            grid-template-columns: 1fr 1fr;
        }
        img {
            border-radius: 10px;
        }
    }
    .content--reverse {
        grid-template-areas: 
            'b' 
            'a';
         @include media-md-up() {
            grid-template-areas: 'b a';
        }
    }
    .content__media {
        grid-area: a;
    }
    .content__text {
        grid-area: b;
    }
}
</style>
